import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import './sanctionOrderModal.css';

const AddBeneficiaryPreview = ({
    showPreview,
    setShowPreview,
    formData,
    handleSubmit,
    title,
    allStates,
    beneficiaryDistricts,
    partnerDistricts,
    allStatus,
}) => {
    const handleClose = () => setShowPreview(false);

    const matchesId = (leftValue, rightValue) => String(leftValue) === String(rightValue);
    const getStateName = (stateId) => allStates.find((state) => matchesId(state.id, stateId))?.name || '';
    const getDistrictName = (districtId, districts) => districts.find((district) => matchesId(district.id, districtId))?.city || '';
    const getStatusName = (statusId) => allStatus.find((status) => matchesId(status.id, statusId))?.title || '';
    const agreementAvailability = formData.is_agreement_available === '1' ? 'Yes' : formData.is_agreement_available === '0' ? 'No' : '';

    return (
        <div>
            <Modal size="lg" show={showPreview} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title} Preview :</Modal.Title>
                </Modal.Header>
                <Modal.Body className='previewModalBody'>
                    <h6>Basic info:</h6>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>{title} Name</th>
                                <th>Address 1</th>
                                <th>Address 2</th>
                                <th>State</th>
                                <th>District</th>
                                <th>Pin Code</th>
                                <th>Contact Person</th>
                                <th>Email</th>
                                <th>Mobile No</th>
                                <th>Landline No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.company_name}</td>
                                <td>{formData.address_1}</td>
                                <td>{formData.address_2}</td>
                                <td>{getStateName(formData.state_id)}</td>
                                <td>{getDistrictName(formData.district, beneficiaryDistricts)}</td>
                                <td>{formData.pin_code}</td>
                                <td>{formData.contact_person}</td>
                                <td>{formData.email}</td>
                                <td>{formData.mobile}</td>
                                <td>{formData.landline_no}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h6>Bank Details:</h6>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Project Name</th>
                                <th>Beneficiary Name</th>
                                <th>Bank Name</th>
                                <th>Branch Name</th>
                                <th>Account No</th>
                                <th>IFSC Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.project_name}</td>
                                <td>{formData.beneficiary_name}</td>
                                <td>{formData.bank_name}</td>
                                <td>{formData.branch_name}</td>
                                <td>{formData.account_no}</td>
                                <td>{formData.ifsc_code}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h6>Statutory Details:</h6>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>PAN</th>
                                <th>PAN Holder Name</th>
                                <th>Status</th>
                                <th>GST No.</th>
                                <th>Reg No MSME Act 2006</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.pan_no}</td>
                                <td>{formData.pan_holder_name}</td>
                                <td>{getStatusName(formData.status)}</td>
                                <td>{formData.gst_no}</td>
                                <td>{formData.reg_no}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h6>Other Details:</h6>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Is vendor agreement available</th>
                                <th>Contract copy</th>
                                <th>Firm Registration Cert.</th>
                                <th>PAN card</th>
                                <th>Authority letter / FC / UBS / NEFT</th>
                                <th>Invoice / Letter Head</th>
                                <th>Cancel cheque</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{agreementAvailability}</td>
                                <td>{formData.contract_copy?.length > 0 ? 'Yes' : 'No'}</td>
                                <td>{formData.reg_cert?.length > 0 ? 'Yes' : 'No'}</td>
                                <td>{formData.pan_card?.length > 0 ? 'Yes' : 'No'}</td>
                                <td>{formData.authority_letter?.length > 0 ? 'Yes' : 'No'}</td>
                                <td>{formData.letter_head?.length > 0 ? 'Yes' : 'No'}</td>
                                <td>{formData.cancel_cheque?.length > 0 ? 'Yes' : 'No'}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h6>Proprieter/Partner/Director Details:</h6>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>PAN</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address 1</th>
                                <th>Address 2</th>
                                <th>State</th>
                                <th>District</th>
                                <th>PIN Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.p_name}</td>
                                <td>{formData.p_pan_no}</td>
                                <td>{formData.p_mobile}</td>
                                <td>{formData.p_email}</td>
                                <td>{formData.p_address_1}</td>
                                <td>{formData.p_address_2}</td>
                                <td>{getStateName(formData.p_state_id)}</td>
                                <td>{getDistrictName(formData.p_district, partnerDistricts)}</td>
                                <td>{formData.p_pincode}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Change
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        SUBMIT
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddBeneficiaryPreview;